import notificationManager from './notificationManager';

// Wrapper functions to replace direct toast calls
export const showSuccessToast = (message, action = 'general') => {
  notificationManager.showUserActionNotification('success', message, action);
};

export const showErrorToast = (message, action = 'general') => {
  notificationManager.showUserActionNotification('error', message, action);
};

// Legacy toast functions for backward compatibility
export const toast = {
  success: (message, options = {}) => {
    const action = options.action || 'general';
    notificationManager.showUserActionNotification('success', message, action);
  },
  error: (message, options = {}) => {
    const action = options.action || 'general';
    notificationManager.showUserActionNotification('error', message, action);
  },
  dismiss: () => {
    notificationManager.clearAllNotifications();
  }
};

// Export notification manager for direct access when needed
export { notificationManager }; 